import React, { useState, useEffect } from "react";
import { Dropdown, Space, Typography, Button } from "antd";
import { DownOutlined, EllipsisOutlined } from "@ant-design/icons";
import { THEME } from "Util/constants";
import { createGlobalStyle } from "styled-components";

const DropdownStyle = createGlobalStyle`
  .green-dropdown .ant-dropdown-menu-item:hover {
    background-color: #3AC9C7 !important;
    color: #fff !important;
  }

  .green-dropdown .ant-dropdown-menu-item-selected {
    background-color: #fff !important;
    color: black !important;
  }
`;

const actionItems = [
  { key: "authorised", label: "Authorised" },
  { key: "declined", label: "Declined" },
  { key: "pending", label: "Pending" }
];

const ActionDropdown = ({ id, onSubmit, isBulk = false, disabled = false, submitLabel = "Submit", dropdownDisabled = false }) => {
  const [selectedKey, setSelectedKey] = useState(id || "pending");
  const isDisabled = submitLabel !== "Resubmit" && selectedKey === id;

  useEffect(() => {
    if (id) setSelectedKey(id);
  }, [id]);

  const selectedLabel =
    actionItems.find(i => i.key === selectedKey)?.label || "Select";

  const handleSelect = ({ key }) => {
    setSelectedKey(key);
    if (isBulk) {
      onSubmit?.(key);
    }
  };

  return (
    <>
      <DropdownStyle />
      <Space>
        <Dropdown
          overlayClassName="green-dropdown"
          trigger={["click"]}
          disabled={dropdownDisabled}
          menu={{
            items: actionItems,
            selectable: true,
            selectedKeys: [selectedKey],
            onClick: handleSelect
          }}
        >
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer"
            }}
          >
            {!isBulk ? (
              <Typography.Link
                style={{
                  width: 100,
                  display: "inline-block",
                  color: dropdownDisabled ? "#aaa" : "black",
                  pointerEvents: dropdownDisabled ? "none" : "auto"
                }}
              >
                <Space
                  style={{
                    width: "100%",
                    justifyContent: "space-between"
                  }}
                >
                  <span
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}
                  >
                    {selectedLabel}
                  </span>

                  <DownOutlined />
                </Space>
              </Typography.Link>
            ) : (
              <EllipsisOutlined />
            )}
          </span>
        </Dropdown>

        {!isBulk && (
          <Button
            type="primary"
            size="small"
            onClick={() => onSubmit?.(selectedKey)}
            disabled={isDisabled || disabled}
            style={{
              backgroundColor:
                isDisabled || disabled
                  ? THEME.colors.gray
                  : THEME.colors.primary,
              color: "white",
              borderColor:
                isDisabled || disabled
                  ? THEME.colors.gray
                  : THEME.colors.primary
            }}
          >
            {submitLabel}
          </Button>
        )}
      </Space>
    </>
  );
};

export default ActionDropdown;
